import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import GrigoraCSSRenderer from "../css-render";
import classNames from "classnames";
import { CMSTemplateSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const CMSTemplate = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node },
  } = useEditor();

  const childrens = node(id).childNodes();

  const { children } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-cms-template": true,
      [`cms-template-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__CMSTemplate(id, props)}`}</style>
      <div className="childrens">
        {Array.isArray(childrens) && childrens.length === 0 ? (
          <>
            <div className="empty-cms-template">Empty CMS Template</div>
          </>
        ) : null}
        {children}
      </div>
    </div>
  );
};

// To Avoid Mangling in Production
CMSTemplate.displayName = "CMSTemplate";

CMSTemplate.craft = {
  name: "CMS Template",
  props: {},
  related: {
    settings: CMSTemplateSettings,
    icon: icon,
    hideFromToolbox: true,
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "CMS Template",
    slug: "grigora/cms-template",
  },
};
